import React from 'react';

import Auth from '@src/auth/auth';
import ResetPassword from '@src/auth/reset-password';

import FlcRoutes from '@flc/app-routes';

import { useAppSelector } from '@store/hooks';

import { IUserSession } from '@entities/user-session';

import '@core/index.css';

declare global {
    interface Window {
        accessToken: string;
    }
}

const appVersion = process.env.REACT_APP_VERSION;

const App = () => {
    const userSession = useAppSelector<IUserSession>((s) => s.userSession);


    if (!userSession) return <Auth appVersion={appVersion} />;

    if (userSession.resetPasswordRequired) return <ResetPassword />;

    return userSession ? <FlcRoutes userSession={userSession} appVersion={appVersion} /> : <Auth appVersion={appVersion} />;
};

export default App;
